/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { ItemHistory } from './ItemHistory';
import {
  ItemHistoryFromJSON,
  ItemHistoryFromJSONTyped,
  ItemHistoryToJSON,
} from './ItemHistory';

/**
 *
 * @export
 * @interface LeadListItem
 */
export interface LeadListItem {
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  callId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  callKey?: string;
  /**
   *
   * @type {string | null}
   * @memberof LeadListItem
   */
  campaignId?: string | null;
  /**
   *
   * @type {number}
   * @memberof LeadListItem
   */
  companyId: number;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  contactKey?: string;
  /**
   *
   * @type {object}
   * @memberof LeadListItem
   */
  csv?: object;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  currentRuleId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  currentRuleKey?: string;
  /**
   *
   * @type {number}
   * @memberof LeadListItem
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof LeadListItem
   */
  dateEstimate?: number;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  dateEstimateIso?: string;
  /**
   *
   * @type {number}
   * @memberof LeadListItem
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {ItemHistory}
   * @memberof LeadListItem
   */
  history?: ItemHistory;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof LeadListItem
   */
  index?: number;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  itemId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  leadId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  leadKey?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  listId: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  resultCode?: LeadListItemResultCodeEnum;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  smsId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  smsKey?: string;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  state?: LeadListItemStateEnum;
  /**
   *
   * @type {string}
   * @memberof LeadListItem
   */
  status?: LeadListItemStatusEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadListItem
   */
  tags?: Array<any>;
}

/**
 * @export
 */
export const LeadListItemResultCodeEnum = {
  CallpowerdialerNoAvailableAgent: 'call:powerdialer_no_available_agent',
  CalloutboundConnected: 'call:outbound_connected',
  CallpowerdialerVmDrop: 'call:powerdialer_vm_drop',
  CallmachineDetected: 'call:machine_detected',
  CallpowerdialerCall: 'call:powerdialer_call',
  Callactive: 'call:active',
  Calloutbound: 'call:outbound',
  Callcancelled: 'call:cancelled',
  Callinbound: 'call:inbound',
  Callmissed: 'call:missed',
  Callanswered: 'call:answered',
  Callabandoned: 'call:abandoned',
  CalluserInitiated: 'call:user_initiated',
  Calldnc: 'call:dnc',
  CalltimegateFailed: 'call:timegate_failed',
  CallnoConsent: 'call:no_consent',
  Callskipped: 'call:skipped',
  Smsdnt: 'sms:dnt',
  SmstimegateFailed: 'sms:timegate_failed',
  SmsnoConsent: 'sms:no_consent',
  Smsskipped: 'sms:skipped',
  Smsaccepted: 'sms:accepted',
  SmsinvalidDestination: 'sms:invalid_destination',
  SmsinvalidSource: 'sms:invalid_source',
  SmsnoRoute: 'sms:no_route',
  SmsrejectedSpam: 'sms:rejected_spam',
  SmsinternalError: 'sms:internal_error',
  Smsrejected: 'sms:rejected',
  SmsnotSupported: 'sms:not_supported',
  SmstimeOut: 'sms:time_out',
  Smserror: 'sms:error',
  Smsunknown: 'sms:unknown',
  SmsownerNoInternationalMessaging: 'sms:owner_no_international_messaging',
  SmsunregisteredA2pNotAllowed: 'sms:unregistered_a2p_not_allowed',
  SmsownerNotEnoughSmsCredits: 'sms:owner_not_enough_sms_credits',
  SmsownerNotEnoughCredits: 'sms:owner_not_enough_credits',
  SmsmessagingDisabled: 'sms:messaging_disabled',
  SmsownerFreeUser: 'sms:owner_free_user',
  SmscontactMissingNumber: 'sms:contact_missing_number',
  SmscontactIsRoom: 'sms:contact_is_room',
  SmscontactIsSharedLine: 'sms:contact_is_shared_line',
  SmsstaffContact: 'sms:staff_contact',
  SmscompanyAffinity: 'sms:company_affinity',
  SmsnotInFreeCompany: 'sms:not_in_free_company',
  SmsinvalidNumber: 'sms:invalid_number',
} as const;
export type LeadListItemResultCodeEnum =
  (typeof LeadListItemResultCodeEnum)[keyof typeof LeadListItemResultCodeEnum];

/**
 * @export
 */
export const LeadListItemStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type LeadListItemStateEnum =
  (typeof LeadListItemStateEnum)[keyof typeof LeadListItemStateEnum];

/**
 * @export
 */
export const LeadListItemStatusEnum = {
  Upcoming: 'Upcoming',
  Active: 'Active',
  InProgress: 'In Progress',
  Scheduled: 'Scheduled',
  Rescheduled: 'Rescheduled',
  Complete: 'Complete',
  Error: 'Error',
} as const;
export type LeadListItemStatusEnum =
  (typeof LeadListItemStatusEnum)[keyof typeof LeadListItemStatusEnum];

/**
 * Check if a given object implements the LeadListItem interface.
 */
export function instanceOfLeadListItem(value: object): value is LeadListItem {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  if (!('listId' in value) || value['listId'] === undefined) return false;
  return true;
}

export function LeadListItemFromJSON(json: any): LeadListItem {
  return LeadListItemFromJSONTyped(json, false);
}

export function LeadListItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadListItem {
  if (json == null) {
    return json;
  }
  return {
    callId: json['call_id'] == null ? undefined : json['call_id'],
    callKey: json['call_key'] == null ? undefined : json['call_key'],
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    companyId: json['company_id'],
    contactId: json['contact_id'] == null ? undefined : json['contact_id'],
    contactKey: json['contact_key'] == null ? undefined : json['contact_key'],
    csv: json['csv'] == null ? undefined : json['csv'],
    currentRuleId:
      json['current_rule_id'] == null ? undefined : json['current_rule_id'],
    currentRuleKey:
      json['current_rule_key'] == null ? undefined : json['current_rule_key'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateEstimate:
      json['date_estimate'] == null ? undefined : json['date_estimate'],
    dateEstimateIso:
      json['date_estimate_iso'] == null ? undefined : json['date_estimate_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    history:
      json['history'] == null
        ? undefined
        : ItemHistoryFromJSON(json['history']),
    id: json['id'],
    index: json['index'] == null ? undefined : json['index'],
    itemId: json['item_id'] == null ? undefined : json['item_id'],
    key: json['key'],
    leadId: json['lead_id'] == null ? undefined : json['lead_id'],
    leadKey: json['lead_key'] == null ? undefined : json['lead_key'],
    listId: json['list_id'],
    resultCode: json['result_code'] == null ? undefined : json['result_code'],
    smsId: json['sms_id'] == null ? undefined : json['sms_id'],
    smsKey: json['sms_key'] == null ? undefined : json['sms_key'],
    state: json['state'] == null ? undefined : json['state'],
    status: json['status'] == null ? undefined : json['status'],
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function LeadListItemToJSON(value?: LeadListItem | null): any {
  if (value == null) {
    return value;
  }
  return {
    call_id: value['callId'],
    call_key: value['callKey'],
    campaign_id: value['campaignId'],
    company_id: value['companyId'],
    contact_id: value['contactId'],
    contact_key: value['contactKey'],
    csv: value['csv'],
    current_rule_id: value['currentRuleId'],
    current_rule_key: value['currentRuleKey'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_estimate: value['dateEstimate'],
    date_estimate_iso: value['dateEstimateIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    history: ItemHistoryToJSON(value['history']),
    id: value['id'],
    index: value['index'],
    item_id: value['itemId'],
    key: value['key'],
    lead_id: value['leadId'],
    lead_key: value['leadKey'],
    list_id: value['listId'],
    result_code: value['resultCode'],
    sms_id: value['smsId'],
    sms_key: value['smsKey'],
    state: value['state'],
    status: value['status'],
    tags: value['tags'],
  };
}
